const PLAYABLE_GAME_STATUSES = new Set(['in_progress', 'won', 'lost']);

export const hasAuthoritativeSessionPayload = (state = {}) => {
  return Boolean(
    state.sessionId &&
      state.caseId &&
      PLAYABLE_GAME_STATUSES.has(state.gameStatus) &&
      state.caseData &&
      state.guideCharacter
  );
};

export const shouldReloadStoredSession = (state = {}) => {
  if (!state.sessionId) {
    return false;
  }

  return !hasAuthoritativeSessionPayload(state);
};
